import { render, staticRenderFns } from "./Login-1.vue?vue&type=template&id=35256816&scoped=true&"
import script from "./Login-1.vue?vue&type=script&lang=js&"
export * from "./Login-1.vue?vue&type=script&lang=js&"
import style0 from "./Login-1.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Login-1.vue?vue&type=style&index=1&id=35256816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35256816",
  null
  
)

export default component.exports